import React from "react";
import { Layout, Row, Col } from "antd";
import HeaderNavigationContainer from "../../components/HeaderNavigation/container";
import Block from "../../components/Block";
import BlogBlock from "../../components/BlogBlock";
import AvatarBlock from "../../components/AvatarBlock";
import BackgroundBlock from "../../components/BackgroundBlock";
import FooterContainer from "../../components/Footer/container";
import blockImage from "../../assets/self-eval-chart.png";
import tool5Image from "../../assets/tools-5.png";
import cultureImage from "../../assets/culture.jpeg";
import communicationImage from "../../assets/communication.jpeg";
import changeImage from "../../assets/post-cover.jpeg";
import intl from "./intl";
import {getBackgroundImage} from '../../infrastructure/helpers/getBackgroundImage'

const { Header, Content } = Layout;
function OurTool(props) {

  return (
    <Layout
      className="layout homebg"
      style={{
        background: `url(${getBackgroundImage('tools')}) no-repeat center center fixed`,
        backgroundSize: "cover"
      }}
    >
      <HeaderNavigationContainer />
      <Header className="">
        <div
          style={{
            color: "#fff",
            position: "relative",
            width: "100%",
            bottom: 0,
            marginTop: "10%"
          }}
        >
          <h1 className="header_headline">{intl.headline[props.language]}</h1>
          <div
            style={{
              position: "absolute",
              zIndex: 10,
              margin: "0 auto",
              left: 0,
              right: 0,
              marginTop: "-20px"
            }}
          >
            <button
              onClick={() => window.scrollBy(0, 700)}
              className="arrow_button"
            >
              <i className="arrow arrow_down" />
            </button>
          </div>
        </div>
      </Header>
      <Content>
        <Block
          anchorId="tools"
          headline={intl.block1.headline[props.language]}
          headlineBody={intl.block1.subHeadline[props.language]}
          body={intl.block1.body[props.language]}
          buttonTxt={intl.goToTestButton[props.language]}
          buttonLink="/360/survey"
          padding="100px 0 "
        />
        <Row style={{ backgroundColor: "#fff" }}>
          <Col sm={24} md={{ span: 12, offset: 6 }}>
            <div style={{ padding: "0" }}>
              <hr className="ourTool_divider" />
              <div
                style={{
                  color: "#1abc9c",
                  backgroundColor: "#fff",
                  display: "inline-block",
                  /* position: absolute, */
                  padding: "0 20px",
                  top: "-25px",
                  position: "relative",
                  fontSize: "20px"
                }}
              >
                {intl.divider1[props.language]}
              </div>
            </div>
          </Col>
        </Row>

        <BlogBlock
          img={blockImage}
          headline={intl.block2.headline[props.language]}
          body={intl.block2.body[props.language]}
          buttonTxt={intl.goToTestButton[props.language]}
          displayReadMore
          centerButton
          readMoreLink="/360/survey"
        />

        {/* <TaBlock buttonLink="/survey" /> */}

        <AvatarBlock
          list={[
            {
              image: cultureImage,
              headline: intl.block3.headline1[props.language],
              subHeadline: intl.block3.subheadline1[props.language],
              body: intl.block3.body1[props.language]
            },
            {
              image: communicationImage,
              headline: intl.block3.headline2[props.language],
              subHeadline: intl.block3.subheadline2[props.language],
              body: intl.block3.body2[props.language]
            },
            {
              image: changeImage,
              headline: intl.block3.headline3[props.language],
              subHeadline: intl.block3.subheadline3[props.language],
              body: intl.block3.body3[props.language]
            }
          ]}
        />

        <Row>
          <Col md={24} className="ourTool_triangle_block">
            <BlogBlock
              paddingContent="200px 0 100px"
              lang={props.lang}
              img={tool5Image}
              headline={intl.block4.headline[props.language]}
              body={intl.block4.body[props.language]}
            />
          </Col>
        </Row>

        <BackgroundBlock
          subHeadline={intl.block5.subheadline[props.language]}
          headline={intl.block5.headline[props.language]}
        />
      </Content>
      <FooterContainer />
    </Layout>
  );
}
export default OurTool;



// WEBPACK FOOTER //
// ./src/pages/OurTool/index.js